/**
 * Created by sy on 2018/9/18.
 */
import fetch from "../api/fetch";
import { INDEX } from "./mutations-type";

export default {
  getBannerData({ commit }) {
    // console.log('进入action')
    let url = "index.php/mobile/index/banner-list";
    let params = {
      user_id: localStorage.getItem("_user_data_id"),
      company_id: localStorage.getItem("_user_data_company_id"),
      sso_token: localStorage.getItem("_user_data_sso_token"),
      sys_id: localStorage.getItem("_sys_id"),
      language: localStorage.getItem("_user_data_language"),
      size: 5,
    };
    fetch.get(url, params).then((res) => {
      // console.log('请求成功')
      // console.log(res.data.result.list);
      commit(INDEX.BANNERLIST, res);
    });
  },
};
